import React from "react";
import { Sparkles } from "lucide-react";

// Playful "✨ 93% Match" badge. size: sm | md | lg
const sizes = {
  sm: "text-xs px-2.5 py-1",
  md: "text-sm px-3 py-1.5",
  lg: "text-base px-4 py-2",
};

export default function MatchBadge({ score, label = "Match", size = "md", className = "" }) {
  return (
    <span
      data-testid="match-badge"
      className={`inline-flex items-center gap-1 font-bold rounded-pill bg-yellow text-ink ink-border ${sizes[size]} ${className}`}
    >
      <Sparkles size={size === "sm" ? 14 : size === "md" ? 16 : 18} className="text-purple" />
      {score}% {label}
    </span>
  );
}
